import * as editJournalActionTypes from '../actionTypes/editJournalForm';
import * as editResumeActionTypes from '../actionTypes/editResumeForm';
import * as editCoverLetterActionTypes from '../actionTypes/editCoverLetterForm';
import getDocumentData from '../../helpers/getDocumentData';
import { FormatTypes } from '../../../constants/templateDictionaries';
import journalInitialState from '../../reducersState/editJournalStateHandlers/getEditJournalFormInitialState';
import resumeInitialState from '../../constants/resumeInitialState';
import coverLetterInitialState from '../../constants/coverLetterInitialState';
import { undoHistory, redoHistory } from '../../helpers/getUpdatedHistory';

const editDocumentForm = {
  /**
   * Gets triggered on component mount of a document
   */
  setInitialDocumentData: (params) => (dispatch) => {
    const { formatType } = params;
    const initialData = getDocumentData(params);
    let actionData = {
      payload: {
        ...initialData,
      },
    };

    if (formatType === FormatTypes.JOURNAL) {
      actionData = {
        ...actionData,
        type: editJournalActionTypes.SET_JOURNAL_INITIAL_STATE,
      };
    } else if (formatType === FormatTypes.RESUME) {
      actionData = {
        ...actionData,
        type: editResumeActionTypes.SET_RESUME_INITIAL_STATE,
      };
    } else if (formatType === FormatTypes.COVER_LETTER) {
      actionData = {
        ...actionData,
        type: editCoverLetterActionTypes.SET_COVER_LETTER_INITIAL_STATE,
      };
    }

    dispatch(actionData);
  },
  setInitialDocumentData1: (params) => (dispatch) => {
    const { formatType, documentData } = params;

    let actionData = {
      payload: {
        ...documentData,
      },
    };

    if (formatType === FormatTypes.JOURNAL) {
      actionData = {
        ...actionData,
        type: editJournalActionTypes.SET_JOURNAL_INITIAL_STATE,
      };
    } else if (formatType === FormatTypes.RESUME) {
      actionData = {
        ...actionData,
        type: editResumeActionTypes.SET_RESUME_INITIAL_STATE,
      };
    } else if (formatType === FormatTypes.COVER_LETTER) {
      actionData = {
        ...actionData,
        type: editCoverLetterActionTypes.SET_COVER_LETTER_INITIAL_STATE,
      };
    }

    dispatch(actionData);
  },

  updateUserPreferences: (params) => (dispatch) => {
    const { formatType, userPreferences, updateType } = params;
    let actionData = {
      payload: {
        userPreferences: { ...userPreferences },
        updateType,
      },
    };

    if (formatType === FormatTypes.RESUME) {
      actionData = {
        ...actionData,
        type: editResumeActionTypes.UPDATE_USER_PREFERENCES,
      };
    } else if (formatType === FormatTypes.JOURNAL) {
      actionData = {
        ...actionData,
        type: editJournalActionTypes.UPDATE_USER_PREFERENCES,
      };
    } else if (formatType === FormatTypes.COVER_LETTER) {
      actionData = {
        ...actionData,
        type: editCoverLetterActionTypes.UPDATE_USER_PREFERENCES,
      };
    }

    dispatch(actionData);
  },

  updateDocumentName: (params) => (dispatch) => {
    const { formatType, documentName } = params;
    let actionData = {
      payload: {
        documentName,
      },
    };

    if (formatType === FormatTypes.RESUME) {
      actionData = {
        ...actionData,
        type: editResumeActionTypes.UPDATE_DOCUMENT_NAME,
      };
    } else if (formatType === FormatTypes.JOURNAL) {
      actionData = {
        ...actionData,
        type: editJournalActionTypes.UPDATE_DOCUMENT_NAME,
      };
    } else if (formatType === FormatTypes.COVER_LETTER) {
      actionData = {
        ...actionData,
        type: editCoverLetterActionTypes.UPDATE_DOCUMENT_NAME,
      };
    }

    dispatch(actionData);
  },

  setDocumentOnUnmount: (params) => (dispatch) => {
    const { formatType, selectedPlan, universityPlan } = params;
    let actionData;
    if (formatType === FormatTypes.JOURNAL) {
      actionData = {
        type: editJournalActionTypes.SET_UNMOUNT_DATA,
        payload: {
          ...journalInitialState,
        },
      };
    } else if (formatType === FormatTypes.RESUME) {
      const resumeDefaultValues = resumeInitialState({
        selectedPlan,
        universityPlan,
      });
      actionData = {
        type: editResumeActionTypes.SET_UNMOUNT_DATA,
        payload: {
          ...resumeDefaultValues,
        },
      };
    } else if (formatType === FormatTypes.COVER_LETTER) {
      const coverLetterDefaultValues = coverLetterInitialState({
        selectedPlan,
        universityPlan,
      });
      actionData = {
        type: editCoverLetterActionTypes.SET_UNMOUNT_DATA,
        payload: {
          ...coverLetterDefaultValues,
        },
      };
    }

    if (actionData) dispatch(actionData);
  },

  setHistory: (params) => (dispatch) => {
    const { historyType, formatType } = params;

    let history;
    if (historyType === 'undo') {
      ({ history } = undoHistory(params));
    } else if (historyType === 'redo') {
      ({ history } = redoHistory(params));
    }

    if (!history) return;

    let actionData = {
      payload: {
        history,
      },
    };

    if (formatType === FormatTypes.RESUME) {
      actionData = {
        ...actionData,
        historyType,
        type: editResumeActionTypes.UPDATE_HISTORY,
      };
    } else if (formatType === FormatTypes.JOURNAL) {
      actionData = {
        ...actionData,
        historyType,
        type: editJournalActionTypes.UPDATE_HISTORY,
      };
    } else if (formatType === FormatTypes.COVER_LETTER) {
      actionData = {
        ...actionData,
        historyType,
        type: editCoverLetterActionTypes.UPDATE_HISTORY,
      };
    }

    dispatch(actionData);
  },
};

export default editDocumentForm;
